export enum Theme {
  PJ = 'pj',
  PF = 'pf',
  WM = 'wm',
  ID = 'id',
  CITRUS = 'citrus-cms',
}
